import { useCallback, useEffect, useState } from 'react';

export const useRetry = (fn: () => void, timeMS: number, maxRequests: number) => {
	const [hasExceededMaxRequests, setHasExceededMaxRequests] = useState(false);
	const [isDone, setIsDone] = useState(false);
	const [requestCount, setRequestCount] = useState(0);
	const stopRetry = useCallback(() => setIsDone(true), [setIsDone]);

	useEffect(() => {
		if (isDone || hasExceededMaxRequests) {
			return;
		}
		if (requestCount >= maxRequests) {
			setHasExceededMaxRequests(true);
		}
	}, [hasExceededMaxRequests, isDone, maxRequests, requestCount]);

	useEffect(() => {
		let timeout: NodeJS.Timeout | undefined;
		if (!hasExceededMaxRequests && !isDone) {
			timeout = setTimeout(() => {
				fn();
				setRequestCount(requestCount + 1);
			}, timeMS);
		}

		return () => timeout && clearTimeout(timeout);
	}, [fn, hasExceededMaxRequests, isDone, timeMS, requestCount]);

	return { hasExceededMaxRequests, stopRetry, count: requestCount };
};
